module.exports = __webpack_public_path__ + "07e2f959a334b21888b8423108817473.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/amy-cheng.jpg
 ** module id = 400
 ** module chunks = 0
 **/